import React from 'react';
import {Flex} from '@components';
import {Button, Checkbox, message, Modal, Radio} from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import './index.css';
import NHFetch from "@utils/NHFetch";
import createHistory from 'history/createHashHistory';
import {getLoginUser} from "@utils/NHCore";
import CommonTip from "../common";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";

const history = createHistory();
const confirm = Modal.confirm;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mkbz: 'GD016_1',
      hjmc: '',
      nextUrl: '',//左侧菜单加载完后传进来
      search: '',
      operable: true,//是否显示环节
      nonOperationalData: {},//不可操作的数据
      blztFlag: "0",
    };
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  componentDidMount() {
    this.queryQztjAndYlhj();
    this.getXsSjh();
  }
  getXsSjh = () => {
    NHFetch('/ahykdx/getYzsjh', 'get').then(res => {
      if (res) {
        if (res.data) {
          this.setState({
            phone: res.data
          })
        }
      }
    })
  }

  //查询前置条件和依赖环节
  queryQztjAndYlhj = (callback) => {
    let xsid = getLoginUser() ? getLoginUser().userId : '';
    if (!xsid) {
      this.setState({
        nonOperationalData: {nologin: true},
        operable: false,
      });
      return;
    }
    let zzbdhjid = this.getUrlParams('pkid');
    NHFetch("/zzbd/queryQztjAndYlhj", 'GET', {xsid: xsid, zzbdhjid: zzbdhjid})
        .then(res => {
          if (res && res.data) {
            let kfsj = res.data['kfsj'];
            let ylhj = res.data['ylhj'];
            let qzhj = res.data['qzhj'];
            let nohj = res.data['nohj'];
            this.setState({nonOperationalData: res.data});
            if (kfsj && kfsj['YXSJ'] != '1') {
              this.setState({operable: false});
            }

            if (ylhj && ylhj.length > 0) {
              this.setState({operable: false});
            }

            if (qzhj && qzhj.length > 0) {
              this.setState({operable: false});
            }
            if (nohj) {
              this.setState({operable: false});
            }
            if (callback) {
              callback(this.state.operable);
            }
          }
        });
  };

  setMenuList = (menuList) => {
    let nextCount = 0;
    let bz = this.state.mkbz;
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC;
        let blztFlag = elem.BLZT;
        this.setState({hjmc, blztFlag})
        nextCount = index + 1;
        return;
      }
    });
    let menu = menuList[nextCount];
    if (menu) {
      let hjdm = menu.HJDM;
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm];
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID,
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = "/customLink";
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: '',
      })
    }
  }

  //获取url中传递的参数
  getUrlParams = (param) => {
    return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  };


  //重新加载菜单
  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }

  sendCode = () => {
    const phone = this.state.phone;
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      Modal.error({ title: '提示', content: '请输入正确的手机号' });
      return;
    }
    // TODO: 在这里调用后端发送验证码接口
    console.log("发送验证码到:", phone);
    NHFetch("/ahykdx/sendCode", 'POST', {phone: phone}).then(res => {
      if (res && res.code == 200){
        if (res.data == 1){
          message.success("验证码已发送")
          this.timer = setInterval(() => {
            this.setState(prev => {
              if (prev.countdown <= 1) {
                clearInterval(this.timer);
                return { countdown: 0 };
              }
              return { countdown: prev.countdown - 1 };
            });
          }, 1000);
          this.setState({ countdown: 180 });
        }else{
          message.error("验证码发送失败！")
        }
      }
    })
  }
  submit = () => {
    const code = this.state.code;
    const phone = this.state.phone;
    if (!phone){
      message.warn("请输入手机号！")
      return
    }
    if (!code){
      message.warn("请输入验证码！")
      return
    }
    let zzbdhjid = this.getUrlParams('pkid')
    // 开始验证
    NHFetch("/ahykdx/validateCode", 'POST', {phone: phone, code: code,zzbdhjid: zzbdhjid}).then(res => { 
      if (res && res.code == 200){
        message.success("验证成功")
        this.reloadMenu();
      }
    })
  }
  render() {
    const {blztFlag} = this.state;
    return (
        <div>{this.state.operable ?
            <Flex className="w1180 mt-20" align="start">
              <SiderMenu
                  ref={"siderMenu"}
                  setMenuList={this.setMenuList}
                  title="自助报到"
                  mkbz={this.state.mkbz}
                  menuType="自助报到"
              />
              <Flex.Item className="page_con_r" styleName="">
                <Breadcrumb
                    noLine
                    list={[
                      {name: '首页', url: '/index'},
                      {name: '自助报到', url: '/register'},
                      {name: this.state.hjmc}
                    ]}
                />
                <div className="box">
                  <Hint/>
                  <TitleTop
                      className="mt-20"
                      title={this.state.hjmc}
                      extra={false}
                  >
                  </TitleTop>
                  {blztFlag == '0' ? 
                  <div>
                    <div style={{ maxWidth: 400, margin: '0 auto' }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={{ display: 'block', marginBottom: 8 }}>手机号</label>
                        <input
                            type="text"
                            value={this.state.phone || ''}
                            onChange={e => this.setState({ phone: e.target.value })}
                            placeholder="请输入手机号"
                            style={{
                              width: '100%',
                              height: 40,
                              padding: '0 10px',
                              borderRadius: 4,
                              border: '1px solid #ddd'
                            }}
                        />
                      </div>

                      <div style={{ marginBottom: 20 }}>
                        <label style={{ display: 'block', marginBottom: 8 }}>验证码</label>
                        <div style={{ display: 'flex', gap: 10 }}>
                          <input
                              type="text"
                              value={this.state.code || ''}
                              onChange={e => this.setState({ code: e.target.value })}
                              placeholder="请输入验证码"
                              style={{
                                flex: 1,
                                height: 40,
                                padding: '0 10px',
                                borderRadius: 4,
                                border: '1px solid #ddd'
                              }}
                          />
                          <button
                              disabled={this.state.countdown > 0}
                              onClick={() => this.sendCode()}
                              style={{
                                width: 120,
                                height: 40,
                                border: 'none',
                                borderRadius: 4,
                                background: this.state.countdown > 0 ? '#ccc' : '#397ef0',
                                color: '#fff',
                                cursor: this.state.countdown > 0 ? 'not-allowed' : 'pointer'
                              }}
                          >
                            {this.state.countdown > 0 ? `${this.state.countdown}s` : '发送验证码'}
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>: <div>
                        <div style={{ maxWidth: 400, margin: '0 auto', textAlign: 'center', padding: '20px 0' }}>
                          <div style={{ fontSize: 16, marginBottom: 10 }}>已验证手机号</div>
                          <div style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: '#397ef0',
                            background: '#f9f9f9',
                            padding: '10px 0',
                            borderRadius: 4,
                            border: '1px solid #ddd'
                          }}>
                            {this.state.phone
                                ? this.state.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
                                : '暂无手机号'}
                          </div>
                        </div>
                      </div>}
                  <div className="text-center mt-50">
                    {blztFlag === '0' ? <Button onClick={this.submit} type={'primary'}>验证</Button>
                        : <Button disabled={true} type={'primary'}>已完成验证</Button>}
                    <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                  </div>
                  <style jsx="true" global="true">
                    {`
                        .ant-result-title {
                            font-size: 20px !important;
                        }
                    `}
                  </style>
                </div>
              </Flex.Item>
            </Flex> : <CommonTip hjmc={"手机号码验证"} key={'GD016_1'} mkbz='GD016_1'
                                 nonOperationalData={this.state.nonOperationalData}/>}
        </div>
    );
  }
}
